<script setup lang="ts">
const { footerBlockItems = [], displayNewsletterSubscriptionForm = true } =
  defineProps<{
    footerBlockItems?: any[]
    displayNewsletterSubscriptionForm?: boolean
  }>()
</script>
<template>
  <RenderOnIntersection>
    <NewsletterSubscriptionForm
      v-if="displayNewsletterSubscriptionForm"
      title-class="text-h5"
    />
  </RenderOnIntersection>
  <div
    class="pb-20 md:pb-24 -mb-1 bg-teal-900 overflow-hidden"
    :class="[
      {
        'pt-40 md:pt-44': displayNewsletterSubscriptionForm,
        'mt-20': !displayNewsletterSubscriptionForm,
      },
      $attrs.class,
    ]"
  >
    <div
      class="max-w-screen-xl mx-auto p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      <div
        v-for="(column, columnIndex) in footerBlockItems"
        :key="`footer-column-${column.title}`"
        class="mt-4"
      >
        <FooterBlock :title="column.title" :items="column.items" />
        <Button
          v-if="columnIndex === 1"
          :aria-label="$t('footer.revokeContract')"
          class="bg-lime-500 text-teal-900 hover:bg-lime-400 text-sm font-semibold mt-2 py-1 px-2 rounded-md"
          link="https://ewif8.share-eu1.hsforms.com/2QkARdvfZS969Leh7wggqaQ"
          open-new-tab
        >
          {{ $t('footer.revokeContract') }}
        </Button>
      </div>
    </div>
  </div>
</template>
